module.exports = __webpack_public_path__ + "images/huazhu1.jpg?v=962ae82a";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/index/huazhu1.jpg
 ** module id = 106
 ** module chunks = 1 2
 **/